/* CLARUS — theme behaviour (no dependencies) */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartType = document.body.getAttribute('data-cart-type') || 'drawer';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function toast(msg) {
    var el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { el.hidden = true; }, 3200);
  }

  /* ---------------- Theme toggle ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-theme-toggle]');
    if (!btn) return;
    var html = document.documentElement;
    var next = html.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    html.setAttribute('data-theme', next);
    try { localStorage.setItem('clarus-theme', next); } catch (err) {}
  });

  /* ---------------- Header height (for mobile menu) ---------------- */
  function setHeaderBottom() {
    var header = $('.site-header');
    if (!header) return;
    var r = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--header-bottom', Math.max(0, r.bottom) + 'px');
  }
  setHeaderBottom();
  window.addEventListener('resize', setHeaderBottom);
  window.addEventListener('scroll', setHeaderBottom, { passive: true });
  $$('.menu-drawer').forEach(function (d) {
    d.addEventListener('toggle', function () {
      setHeaderBottom();
      document.body.classList.toggle('no-scroll', d.open);
    });
  });

  /* ---------------- Quantity steppers ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && $('input', wrap);
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var val = (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-step'), 10);
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Cart ---------------- */
  var Cart = {
    drawer: function () { return $('#CartDrawer'); },

    open: function () {
      var d = Cart.drawer();
      if (!d) { window.location.href = root + 'cart'; return; }
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
      var close = $('[data-drawer-close]', d);
      if (close) close.focus();
    },

    close: function () {
      var d = Cart.drawer();
      if (!d) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
    },

    setCount: function (count) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count < 1;
      });
    },

    renderSections: function (sections) {
      if (!sections) return;
      if (sections['cart-drawer']) {
        var tmp = document.createElement('div');
        tmp.innerHTML = sections['cart-drawer'];
        var fresh = $('#CartDrawerInner', tmp);
        var current = $('#CartDrawerInner');
        if (fresh && current) current.replaceWith(fresh);
      }
    },

    refresh: function () {
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { Cart.setCount(cart.item_count); return cart; });
    },

    add: function (formData) {
      if (Cart.drawer()) formData.append('sections', 'cart-drawer');
      formData.append('sections_url', window.location.pathname);
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
          return data;
        });
      }).then(function (data) {
        Cart.renderSections(data.sections);
        return Cart.refresh();
      });
    },

    change: function (line, quantity) {
      var d = Cart.drawer();
      if (d) d.classList.add('is-busy');
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || data.message);
          Cart.renderSections(data.sections);
          Cart.setCount(data.item_count);
        })
        .catch(function (err) { toast(err.message || 'Could not update cart'); })
        .then(function () { if (d) d.classList.remove('is-busy'); });
    }
  };
  window.ClarusCart = Cart;

  // Add-to-cart forms
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form || cartType !== 'drawer' || !Cart.drawer()) return;
    e.preventDefault();
    var btn = $('[type="submit"]', form);
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
    var errorEl = $('[data-form-error]', form);
    if (errorEl) errorEl.hidden = true;
    Cart.add(new FormData(form))
      .then(function () { Cart.open(); })
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        else toast(err.message);
      })
      .then(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
      });
  });

  // Open / close drawer
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]') && cartType === 'drawer' && Cart.drawer()) {
      e.preventDefault();
      Cart.open();
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); Cart.close(); return; }
    var rm = e.target.closest('[data-line-remove]');
    if (rm && rm.closest('#CartDrawer')) {
      e.preventDefault();
      Cart.change(parseInt(rm.getAttribute('data-line-remove'), 10), 0);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') Cart.close();
  });

  // Quantity changes inside the drawer
  document.addEventListener('change', function (e) {
    var input = e.target.closest('#CartDrawer [data-line-qty]');
    if (!input) return;
    Cart.change(parseInt(input.getAttribute('data-line-qty'), 10), Math.max(0, parseInt(input.value, 10) || 0));
  });

  // Quantity changes on the cart page: submit the update form
  document.addEventListener('change', function (e) {
    var input = e.target.closest('form[data-cart-page] [data-line-qty]');
    if (!input) return;
    clearTimeout(input._t);
    input._t = setTimeout(function () { input.form.submit(); }, 400);
  });

  /* ---------------- Variant picker ---------------- */
  $$('[data-product]').forEach(function (productEl) {
    var dataEl = $('[data-product-json]', productEl);
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var form = $('form[data-product-form]', productEl);
    var idInput = form && $('input[name="id"]', form);
    var fieldsets = $$('[data-option-index]', productEl);
    var moneyFormat = productEl.getAttribute('data-money-format') || '${{amount}}';

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
      return moneyFormat
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
        .replace(/\{\{\s*amount\s*\}\}/, withCommas);
    }

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var checked = $('input:checked', fs);
        var sel = $('select', fs);
        return checked ? checked.value : (sel ? sel.value : null);
      });
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function markAvailability(opts) {
      fieldsets.forEach(function (fs, idx) {
        $$('.option__value', fs).forEach(function (wrap) {
          var input = $('input', wrap);
          var test = opts.slice();
          test[idx] = input.value;
          var match = product.variants.find(function (v) {
            return v.available && v.options.every(function (o, i) { return o === test[i]; });
          });
          wrap.classList.toggle('is-unavailable', !match);
        });
      });
    }

    function update() {
      var opts = selectedOptions();
      fieldsets.forEach(function (fs, i) {
        var label = $('[data-option-selected]', fs);
        if (label) label.textContent = opts[i];
      });
      markAvailability(opts);
      var variant = findVariant(opts);
      var btn = $('[data-add-button]', productEl);
      var btnLabel = btn && $('.button__label', btn);

      if (!variant) {
        if (btn) btn.disabled = true;
        if (btnLabel) btnLabel.textContent = 'Unavailable';
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (btn) btn.disabled = !variant.available;
      if (btnLabel) btnLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';

      var priceEl = $('[data-price]', productEl);
      if (priceEl) {
        var html = '<span>' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s>' + formatMoney(variant.compare_at_price) + '</s>';
        }
        priceEl.innerHTML = html;
      }

      var skuEl = $('[data-sku]', productEl);
      if (skuEl) { skuEl.textContent = variant.sku ? 'SKU ' + variant.sku : ''; skuEl.hidden = !variant.sku; }

      var stock = $('[data-stock]', productEl);
      if (stock) {
        var inv = $('[data-variant-inventory="' + variant.id + '"]', productEl);
        stock.className = 'product__stock';
        if (!variant.available) { stock.classList.add('product__stock--out'); stock.textContent = 'Sold out'; }
        else if (inv && inv.getAttribute('data-low') === 'true') { stock.classList.add('product__stock--low'); stock.textContent = inv.textContent; }
        else { stock.textContent = inv ? inv.textContent : 'In stock, ready to ship'; }
      }

      if (variant.featured_media) Gallery.show(productEl, variant.featured_media.id);

      if (window.history && window.history.replaceState && productEl.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
    if (fieldsets.length) markAvailability(selectedOptions());
  });

  /* ---------------- Gallery ---------------- */
  var Gallery = {
    show: function (scope, mediaId) {
      var slides = $$('[data-media-id]', scope);
      if (!slides.length) return;
      var found = false;
      slides.forEach(function (s) {
        var on = String(s.getAttribute('data-media-id')) === String(mediaId);
        if (on) found = true;
        s.classList.toggle('is-active', on);
      });
      if (!found) return;
      $$('[data-thumb-for]', scope).forEach(function (t) {
        t.setAttribute('aria-current', String(t.getAttribute('data-thumb-for')) === String(mediaId) ? 'true' : 'false');
      });
      $$('[data-media-id] video', scope).forEach(function (v) { if (!v.closest('.is-active')) v.pause(); });
    }
  };
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb-for]');
    if (!thumb) return;
    Gallery.show(thumb.closest('[data-product]') || document, thumb.getAttribute('data-thumb-for'));
  });

  /* ---------------- Collection filters ---------------- */
  $$('form[data-facets-form]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="number"]')) return;
      submitFacets(form);
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); submitFacets(form); });
  });
  function submitFacets(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });
    var sort = $('[data-sort-select]');
    if (sort && sort.value) params.set('sort_by', sort.value);
    var q = new URLSearchParams(window.location.search).get('q');
    if (q) params.set('q', q);
    window.location.search = params.toString();
  }
  $$('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
  $$('[data-facets-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.facets');
      var open = wrap.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  /* ---------------- Crystal finder ---------------- */
  $$('[data-finder]').forEach(function (finder) {
    var tabs = $$('[role="tab"]', finder);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', String(on));
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      });
    });

    var sizeForm = $('[data-finder-size]', finder);
    if (sizeForm) {
      sizeForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var base = sizeForm.getAttribute('action');
        var diameter = parseFloat($('[name="diameter"]', sizeForm).value);
        var tol = parseFloat(sizeForm.getAttribute('data-tolerance') || '0.2');
        var shapeKey = sizeForm.getAttribute('data-shape-key');
        var diaKey = sizeForm.getAttribute('data-diameter-key');
        var params = new URLSearchParams();
        if (!isNaN(diameter)) {
          params.set('filter.p.m.' + diaKey + '.gte', (diameter - tol).toFixed(1));
          params.set('filter.p.m.' + diaKey + '.lte', (diameter + tol).toFixed(1));
        }
        $$('[name="shape"]:checked', sizeForm).forEach(function (cb) {
          params.append('filter.p.m.' + shapeKey, cb.value);
        });
        window.location.href = base + (params.toString() ? '?' + params.toString() : '');
      });
    }
  });
})();
